import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './progressBar.scss';

const ProgressBar = ({
  className,
  progress,
  barBgColor = '#fbdfd9',
  progressLineColor = '#ff6e6e',
  progressLineColorWhenMax = '#ea2337',
}) => {
  const [style, setStyle] = useState();

  function setProgressStyle() {
    setStyle(
      progress >= 100
        ? {
            transform: `translateX(0%)`,
            transition: `transform 500ms`,
            WebkitTransition: `transform 500ms`,
            backgroundColor: progressLineColorWhenMax,
          }
        : {
            transition: `transform ${progress * 5}ms`,
            WebkitTransition: `transform ${progress * 5}ms`,
            transform: `translateX(${-100 + progress}%)`,
            backgroundColor: progressLineColor,
          }
    );
  }

  useEffect(() => {
    if (progress > 0) setProgressStyle();
  }, [progress]);

  return (
    <div
      className={`${styles.progressBar}${className ? ` ${className}` : ''}`}
      style={{ backgroundColor: barBgColor }}
    >
      <div
        className={`${styles.progressLine}`}
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuenow={progress > 100 ? 100 : progress}
        style={style}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number,
  barBgColor: PropTypes.string,
  progressLineColor: PropTypes.string,
  progressLineColorWhenMax: PropTypes.string,
};

export default ProgressBar;
